import {
  ANALYTICS_LOADING,
  ANALYTICS_ERROR,
  CLEAR_ANALYTICS,
  FETCH_ANALYTICS_OVERVIEW,
  FETCH_ANALYTICS_VIDEO_STATS,
  FETCH_ANALYTICS_TOP_VIDEOS,
  FETCH_ANALYTICS_VIDEO_TIMELINE,
  FETCH_ANALYTICS_COMMENT_STATS,
  FETCH_ANALYTICS_TOP_COMMENTERS,
  FETCH_ANALYTICS_REACTION_STATS,
  FETCH_ANALYTICS_TOP_REACTED,
  FETCH_ANALYTICS_POST_STATS,
  FETCH_ANALYTICS_BADGE_STATS,
  MUX_ANALYTICS_LOADING,
  MUX_ANALYTICS_ERROR,
  FETCH_QOE_OVERVIEW,
  FETCH_QOE_BY_DEVICE,
  FETCH_QOE_BY_PLAN,
  FETCH_QOE_BY_CATEGORY,
  FETCH_QOE_BY_DIFFICULTY,
  FETCH_QOE_TIMESERIES,
  FETCH_TRAIL_QOE,
  FETCH_TRAIL_ENGAGEMENT,
  FETCH_TRAIL_FUNNEL,
  FETCH_MODULE_QOE,
  FETCH_MODULE_DROP_OFF,
  FETCH_VIDEO_QOE,
  FETCH_VIDEO_ENGAGEMENT,
  FETCH_CONCURRENT_VIEWERS,
  FETCH_STARTUP_HEALTH,
} from "../actions/types";

const initialState = {
  overview: null,
  videoStats: null,
  topVideos: [],
  videoTimeline: { data: [], startDate: null, endDate: null, groupBy: "day" },
  commentStats: null,
  topCommenters: [],
  reactionStats: null,
  topReactedVideos: [],
  postStats: null,
  badgeStats: null,
  // Mux Data Analytics
  qoeOverview: null,
  qoeByDevice: null,
  qoeByPlan: null,
  qoeByCategory: null,
  qoeByDifficulty: null,
  qoeTimeseries: null,
  trailQoe: null,
  trailEngagement: null,
  trailFunnel: null,
  moduleQoe: null,
  moduleDropOff: null,
  videoQoe: null,
  videoEngagement: null,
  concurrentViewers: null,
  startupHealth: null,
  loading: {
    overview: false,
    videos: false,
    topVideos: false,
    timeline: false,
    comments: false,
    topCommenters: false,
    reactions: false,
    topReacted: false,
    posts: false,
    badges: false,
    // Mux loading flags
    qoeOverview: false,
    qoeBreakdowns: false,
    qoeTimeseries: false,
    trailQoe: false,
    trailEngagement: false,
    trailFunnel: false,
    moduleQoe: false,
    moduleDropOff: false,
    videoQoe: false,
    videoEngagement: false,
    monitoring: false,
  },
  error: null,
  muxError: null,
};

export default function analyticsReducer(state = initialState, action) {
  switch (action.type) {
    case ANALYTICS_LOADING:
      return { ...state, loading: { ...state.loading, ...action.payload }, error: null };

    case MUX_ANALYTICS_LOADING:
      return { ...state, loading: { ...state.loading, ...action.payload }, muxError: null };

    case FETCH_ANALYTICS_OVERVIEW:
      return { ...state, overview: action.payload, loading: { ...state.loading, overview: false } };

    case FETCH_ANALYTICS_VIDEO_STATS:
      return { ...state, videoStats: action.payload, loading: { ...state.loading, videos: false } };

    case FETCH_ANALYTICS_TOP_VIDEOS:
      return { ...state, topVideos: action.payload, loading: { ...state.loading, topVideos: false } };

    case FETCH_ANALYTICS_VIDEO_TIMELINE:
      return { ...state, videoTimeline: action.payload, loading: { ...state.loading, timeline: false } };

    case FETCH_ANALYTICS_COMMENT_STATS:
      return { ...state, commentStats: action.payload, loading: { ...state.loading, comments: false } };

    case FETCH_ANALYTICS_TOP_COMMENTERS:
      return { ...state, topCommenters: action.payload, loading: { ...state.loading, topCommenters: false } };

    case FETCH_ANALYTICS_REACTION_STATS:
      return { ...state, reactionStats: action.payload, loading: { ...state.loading, reactions: false } };

    case FETCH_ANALYTICS_TOP_REACTED:
      return { ...state, topReactedVideos: action.payload, loading: { ...state.loading, topReacted: false } };

    case FETCH_ANALYTICS_POST_STATS:
      return { ...state, postStats: action.payload, loading: { ...state.loading, posts: false } };

    case FETCH_ANALYTICS_BADGE_STATS:
      return { ...state, badgeStats: action.payload, loading: { ...state.loading, badges: false } };

    // Mux Data Analytics
    case FETCH_QOE_OVERVIEW:
      return { ...state, qoeOverview: action.payload, loading: { ...state.loading, qoeOverview: false } };

    case FETCH_QOE_BY_DEVICE:
      return { ...state, qoeByDevice: action.payload, loading: { ...state.loading, qoeBreakdowns: false } };

    case FETCH_QOE_BY_PLAN:
      return { ...state, qoeByPlan: action.payload, loading: { ...state.loading, qoeBreakdowns: false } };

    case FETCH_QOE_BY_CATEGORY:
      return { ...state, qoeByCategory: action.payload, loading: { ...state.loading, qoeBreakdowns: false } };

    case FETCH_QOE_BY_DIFFICULTY:
      return { ...state, qoeByDifficulty: action.payload, loading: { ...state.loading, qoeBreakdowns: false } };

    case FETCH_QOE_TIMESERIES:
      return { ...state, qoeTimeseries: action.payload, loading: { ...state.loading, qoeTimeseries: false } };

    case FETCH_TRAIL_QOE:
      return { ...state, trailQoe: action.payload, loading: { ...state.loading, trailQoe: false } };

    case FETCH_TRAIL_ENGAGEMENT:
      return { ...state, trailEngagement: action.payload, loading: { ...state.loading, trailEngagement: false } };

    case FETCH_TRAIL_FUNNEL:
      return { ...state, trailFunnel: action.payload, loading: { ...state.loading, trailFunnel: false } };

    case FETCH_MODULE_QOE:
      return { ...state, moduleQoe: action.payload, loading: { ...state.loading, moduleQoe: false } };

    case FETCH_MODULE_DROP_OFF:
      return { ...state, moduleDropOff: action.payload, loading: { ...state.loading, moduleDropOff: false } };

    case FETCH_VIDEO_QOE:
      return { ...state, videoQoe: action.payload, loading: { ...state.loading, videoQoe: false } };

    case FETCH_VIDEO_ENGAGEMENT:
      return { ...state, videoEngagement: action.payload, loading: { ...state.loading, videoEngagement: false } };

    case FETCH_CONCURRENT_VIEWERS:
      return { ...state, concurrentViewers: action.payload, loading: { ...state.loading, monitoring: false } };

    case FETCH_STARTUP_HEALTH:
      return { ...state, startupHealth: action.payload, loading: { ...state.loading, monitoring: false } };

    case ANALYTICS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: Object.keys(state.loading).reduce((acc, k) => ({ ...acc, [k]: false }), {}),
      };

    case MUX_ANALYTICS_ERROR:
      return {
        ...state,
        muxError: action.payload,
        loading: {
          ...state.loading,
          qoeOverview: false,
          qoeBreakdowns: false,
          qoeTimeseries: false,
          trailQoe: false,
          trailEngagement: false,
          trailFunnel: false,
          moduleQoe: false,
          moduleDropOff: false,
          videoQoe: false,
          videoEngagement: false,
          monitoring: false,
        },
      };

    case CLEAR_ANALYTICS:
      return initialState;

    default:
      return state;
  }
}
